import React from "react";
import "./Navbar.css";
import useCurrentPage from "../hooks/use-current-page.ts";

export const Navbar = () => {
  const pageIds = ["Home", "About", "Price", "Contact"];
  const currentPage = useCurrentPage(pageIds);

  const gotoPage = (id) => {
    document.getElementById(id).scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });
  };

  return (
    <div id="Navbar">
      <div className="navbar-content">
        <p
          className={currentPage === "About" ? "selected" : ""}
          onClick={() => gotoPage("About")}
        >
          About
        </p>
        <p
          className={currentPage === "Price" ? "selected" : ""}
          onClick={() => gotoPage("Price")}
        >
          Price
        </p>
        <p
          className={currentPage === "Contact" ? "selected" : ""}
          onClick={() => gotoPage("Contact")}
        >
          Contact
        </p>
      </div>
    </div>
  );
};

export default Navbar;
